<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-scrollable"
    :close-on-click-modal="false"
    :destroy-on-close="true"
  >
    <div>
      <div class="flex items-center justify-center">
        <circle-icon />
      </div>
      <!-- The id in the next line maps the walkthrough to that p element. Please do not remove this id -->
      <p
        class="lg:text-xl text-lg text-black font-bold text-center mt-4"
        id="fundAcctTourItem3"
      >
        Deposit Pending
      </p>
      <div
        class="mt-3 text-sm text-fg-muted font-normal"
        style="word-break: normal"
      >
        <div class="flex items-start gap-x-1.5 mb-3">
          <p>1.</p>
          <p>
            A pending deposit requires you to initiate a funds transfer from
            your financial institution. Your deposit is labeled pending until
            <span class="capitalize"> {{ tenantName }}</span> receives funds.
          </p>
        </div>
        <div class="flex items-start gap-x-1 mb-3">
          <p>2.</p>
          <p>
            You will not be able to initiate a new deposit until this deposit is
            confirmed.
          </p>
        </div>
      </div>
      <el-button
        class="bg-primary w-full py-3.5 mt-4 text-white rounded-md text-sm font-normal"
        @click="handleClose"
        >I Understand</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import tenant from '@/mixins/tenant'
export default {
  mixins: [tenant],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breakpoints
    }
  },
  components: {
    CircleIcon: () => import('@/assets/icons/CircleIcon.vue')
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog')
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '30%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  }
}
</script>

<style scoped>
>>> .el-dialog {
  border-radius: 16px;
  padding: 5px;
  background-color: white;
}
>>> .el-dialog__close .el-icon .el-icon-close {
  color: black !important;
}
</style>
